export default "__VITE_ASSET__C2vF9SrG__"